import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'

gsap.registerPlugin()

$(document).ready(function() {

  let horizontal_scroll = $('.js-horizontal-scroll')

  if (horizontal_scroll.length) {
    setTimeout(function () {

      if (window.innerWidth > 1000) { // horizontal scroll
        const container = $('.js-horizontal-scroll')[0]
        let sections = gsap.utils.toArray('.cat-el')

        gsap.to(container, {
          x: -(container.scrollWidth - document.documentElement.clientWidth),
          ease: "none",
          scrollTrigger: {
            trigger: container,
            start: "top top",
            pin: true,
            invalidateOnRefresh: true,
            markers: false,
            scrub: 1,
            //snap: 1 / (sections.length - 1),
            end: "+=" + container.offsetWidth
          }
        })
      } else { // slider

        $('.js-resp-cats-slider').slick({
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          arrows: true,
          autoplay: false,
          speed: 1000,
          autoplaySpeed: 5000,
          responsive: [
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            },
          ]
        });

      }


      // draw line
      let draw_timeline = gsap.timeline({
        scrollTrigger: {
          start: () => parseInt($('.horizontal-cats ').offset().top ) +' top',
          end: () => `+=`+($('.js-horizontal-scroll').outerWidth() * 1.1),
          scrub: true,
          markers: false,
          onUpdate: function(progress){
            //console.log()
          }
        },
      })

      const drawLine = (line_svg, i) => {
        let line = $(line_svg).find('.arrow-stroke')
        let line_circle = $(line_svg).find('.arrow-circle')
        let line_circle_in = $(line_svg).find('.arrow-circle-in')
        let delay = 0.2
        if (i == 0) delay = 0

        draw_timeline.to(line_circle, {opacity: 1, duration: 1, ease: 'none'}, ">-"+delay)
        draw_timeline.to(line_circle_in, {opacity: 1, duration: 1, ease: 'none'})
        draw_timeline.from(line,{strokeDashoffset: 1000, ease: 'none', duration: 10}, ">-"+delay)
      }
      const svgs = gsap.utils.toArray(".dotted-arrow-line");
      svgs.forEach(drawLine);

    }, 500)
  }





})
